import { atom } from "./atom";
import { DataTestids } from "./DataTestids";
import { RecoilKeys } from "./RecoilKeys";
import { OrderErrorKey } from "./translationFromErrorCode";

export type NotificationTag = "success" | "warning" | "danger" | "info";
export type Toast = {
  // unintuitively, this `key` spans multiple toasts across NotificationTag values
  // ... this allows success to dismiss all others
  readonly joiningKey: DataTestids | OrderErrorKey;
  readonly message: string;
  readonly tag: NotificationTag;
  // Optional dynamic parameters for translation placeholders (e.g., {0}, {min}, {max})
  readonly args?: Record<string, string>;
};
export type ToastsProps = { readonly toasts: readonly Toast[] };

export const toastsAtom = atom<ToastsProps["toasts"] | null>({
  key: RecoilKeys.Toasts,
  default: [],
});
